import { render } from "./Search.vue?vue&type=template&id=8b66ac00"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=8b66ac00&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__